DialogController = App.loadClass 'core::Angular/DialogController'

class exports.ForgotPasswordController extends DialogController
    constructor: (@scope, @transitions, @modalInstance, @http, @location) ->
        super
        @scope.title = 'Reset Password'
        @scope.user = identifier: @scope.params.email

    save: () =>
        promise = @http.post 'backend/session-mgmt/send-password-reset',
            'identifier': @scope.user.identifier
            'b': @location.search().b

        promise.then (jsr) =>
            @closeWithAlert(jsr.data.status)
